export class QuoteSalesDetail {
  actualCost: number = null;
  addedTimestamp?: Date = null;
  amount: number = null;
  coreReturnFlag: string = null;
  employeeId: string = null;
  goodwrenchFlag: string = null;
  goodwrenchModified: number = null;
  gstAfterDiscount: number = null;
  gstAmount: number = null;
  gstCost: number = null;
  id: number = null;
  inventoryDescription?: string = null;
  inventoryLastSaleDate: Date = null;
  matrixPriceDifference: number = null;
  note: string = null;
  partKitName: string = null;
  partNumber?: string = null;
  partReferenceNumber: string = null;
  partsRoundupDifference: number = null;
  price: number = null;
  priceLock: boolean = null;
  pstAfterDiscount: number = null;
  pstAmount: number = null;
  pstCost: number = null;
  quantity: number = null;
  quoteDetailSequence: number = null;
  quoteHeaderId: number = null;
  remanIndicator: string = null;
  retailPrice: number = null;
  rooftopId: number = null;
  salesTypeId: string = null;
  sequence: number = null;
  sortSequence: number = null;
  subTotalAfterDiscount: number = null;
  subTotalCost: number = null;
  totalAmount: number = null;
  totalCost: number = null;
  transactionTypeId: string = null;
  unitCost: number = null;

  constructor(obj?: QuoteSalesDetail) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
